import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventTrackingService {

  constructor() { }
  logEvent(eventName: string, eventDetails: any): void {
    // Envoyez les données vers une API ou un stockage local ici.
  }
}
